/**
 * Pre-compiled es messages for Select
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { clearSelection: `Borrar selección` };
